import { isNil } from 'lodash';

import { get, CleanSchema } from '../../../json-transform';
import { EVENT_POLICY_TRIGGER_OPTIONS, IMAGE_FORMAT_OPTIONS, SENDING_TYPE_OPTIONS } from '../../constants';
import { createRoiScheme, readRoiScheme, droiScheme } from './roiSchemeHandler';

export const createPeopleCountAnalytic = new CleanSchema({
  analytic_name: get('analytic_name'),
  parameters: {
    parameters: {
      // FIXME: Поле people_count_threshold будет deprecated в скором времени, теперь используем people_count__gte и people_count__lte
      people_count_threshold: get('parameters.parameters').switch(({ people_count__gte, people_count__lte }) => isNil(people_count__gte) && isNil(people_count__lte), {
        true: ({ people_count_threshold }) => people_count_threshold,
        default: () => undefined,
      },
      ),
      people_count__gte: get('parameters.parameters.people_count__gte').ifEmptyString(undefined).asInt(),
      people_count__lte: get('parameters.parameters.people_count__lte').ifEmptyString(undefined).asInt(),
      event_delay: get('parameters.parameters.event_delay').asInt().ifNaN(undefined),
      probe_count: get('parameters.parameters.probe_count').asInt().ifNaN(undefined),
      event_policy: {
        trigger: get('parameters.parameters.event_policy.trigger').asOptionValue(),
        interval: get('parameters.parameters.event_policy.interval').asFloat().ifNaN(undefined),
      },
      image_retain_policy: {
        mimetype: get('parameters.parameters.image_retain_policy.mimetype').asOptionValue(),
        quality: get('parameters.parameters.image_retain_policy.quality').asFloat().ifNaN(undefined),
        max_size: get('parameters.parameters.image_retain_policy.max_size').asInt().ifNaN(undefined),
      },
      rate: {
        unit: get('parameters.parameters.rate.unit').asOptionValue(),
        period: get('parameters.parameters.rate.period').asFloat().ifNaN(undefined),
      },
      roi: get('parameters.parameters.roi').as(createRoiScheme),
      droi: get('parameters.parameters.droi').as(droiScheme),
    },
    targets: get('parameters.targets'),
    callbacks: get('parameters.callbacks').asArrayOf(),
  },
});

export const readPeopleCountAnalytic = new CleanSchema({
  analytic_name: get('analytic_name'),
  parameters: {
    parameters: {
      // FIXME: Поле people_count_threshold будет deprecated в скором времени, теперь используем people_count__gte и people_count__lte
      people_count_threshold: get('parameters.parameters.people_count_threshold'),
      // FIXME: Когда people_count_threshold будет deprecated, то нужно будет удалить проверку .switch,
      // сейчас нужна, чтобы стримы на старом поляе работали, как будто уже везде новое поле приходит
      people_count__gte: get('parameters.parameters').switch(({ people_count__gte }) => !isNil(people_count__gte), {
        true: ({ people_count__gte }) => people_count__gte,
        default: ({ people_count_threshold }) => people_count_threshold,
      },
      ),
      people_count__lte: get('parameters.parameters.people_count__lte'),
      event_delay: get('parameters.parameters.event_delay'),
      probe_count: get('parameters.parameters.probe_count'),
      event_policy: {
        trigger: get('parameters.parameters.event_policy.trigger').asOption(EVENT_POLICY_TRIGGER_OPTIONS),
        interval: get('parameters.parameters.event_policy.interval'),
      },
      image_retain_policy: {
        mimetype: get('parameters.parameters.image_retain_policy.mimetype').asOption(IMAGE_FORMAT_OPTIONS),
        quality: get('parameters.parameters.image_retain_policy.quality'),
        max_size: get('parameters.parameters.image_retain_policy.max_size'),
      },
      rate: {
        unit: get('parameters.parameters.rate.unit').asOption(SENDING_TYPE_OPTIONS),
        period: get('parameters.parameters.rate.period'),
      },
      roi: get('parameters.parameters.roi').as(readRoiScheme),
      droi: get('parameters.parameters.droi').as(droiScheme),
    },
    targets: get('parameters.targets'),
    callbacks: get('parameters.callbacks').asArrayOf(),
  },
  status: get('status'),
  autorestart: get('autorestart'),
});
